import { toast } from "react-toastify";

import {
  PutGaIntegrationRequestBodyType,
  PutGaIntegrationResponseBodyType,
} from "@intelligems/ig-types";
import { useMutation } from "@tanstack/react-query";

import { api } from "../api";
import { ApiRequest } from "../types/api";

const putGaIntegration = async (
  payload: ApiRequest<PutGaIntegrationRequestBodyType>
) => {
  const resp = await api.put<PutGaIntegrationResponseBodyType>(
    `/v2/integrations/google/ga`,
    payload.body
  );
  return resp.data;
};

export const usePutGaIntegration = () => {
  return useMutation<
    PutGaIntegrationResponseBodyType,
    Error,
    ApiRequest<PutGaIntegrationRequestBodyType>,
    any
  >({
    mutationFn: async (data) => putGaIntegration(data),
    onSuccess: () => {
      toast.success("Google Analytics updated!");
    },
  });
};
